export const ScheduleDStepOneExternalLinks = {
    asrTowairSearch:
        'https://wireless2.fcc.gov/UlsApp/AsrSearch/towairSearch.jsp',
    asrRegistrationSearch:
        'https://wireless2.fcc.gov/UlsApp/AsrSearch/asrRegistrationSearch.jsp',
};
